module.exports = __webpack_public_path__ + "Flag-214.a890135a8744f71679f0474c0303672f.svg";